// Action d'une fiche (affecter, transmettre, valider, signer, transition de dossier...) :
// fenêtre de confirmation avec champs, appel réel de la route, succès après réponse du serveur.
import { Bandeau, Bouton, Champ, DialogueConfirmation, Selection, ZoneTexte, type OptionSelection, type VarianteBouton } from '@cc/ui';
import { useState } from 'react';
import { requete } from '../../api/client';
import { useAction } from '../../commun/useAction';

export interface ChampAction {
  nom: string;
  libelle: string;
  aide?: string;
  obligatoire?: boolean;
  multiligne?: boolean;
  /** Liste de choix (sélection) à la place d'une saisie libre ; saisie libre si la liste est vide. */
  options?: OptionSelection[];
}

export interface ProprietesActionMetier {
  libelle: string;
  titre: string;
  explication: string;
  chemin: string;
  champs?: ChampAction[];
  /** Corps fixe ajouté aux champs saisis. */
  corps?: Record<string, unknown>;
  succes: string;
  invalider: (readonly unknown[])[];
  variante?: VarianteBouton;
}

export function ActionMetier({ libelle, titre, explication, chemin, champs = [], corps = {}, succes, invalider, variante = 'principal' }: ProprietesActionMetier) {
  const [ouvert, setOuvert] = useState(false);
  const [valeurs, setValeurs] = useState<Record<string, string>>({});
  const action = useAction({
    executer: () =>
      requete(chemin, {
        methode: 'POST',
        corps: { ...corps, ...Object.fromEntries(Object.entries(valeurs).filter(([, v]) => v.trim() !== '')) },
      }),
    succes,
    invalider,
    apres: () => {
      setOuvert(false);
      setValeurs({});
    },
  });
  const incomplet = champs.some((c) => c.obligatoire && !(valeurs[c.nom] ?? '').trim());
  return (
    <>
      <Bouton variante={variante} onClick={() => setOuvert(true)}>
        {libelle}
      </Bouton>
      <DialogueConfirmation
        ouvert={ouvert}
        titre={titre}
        message={<p>{explication}</p>}
        libelleConfirmer={libelle}
        variante={variante}
        enCours={action.enCours}
        confirmationDesactivee={incomplet}
        onConfirmer={() => action.lancer(undefined)}
        onAnnuler={() => {
          setOuvert(false);
          action.reinitialiser();
        }}
      >
        {champs.map((c) =>
          c.options && c.options.length > 0 ? (
            <Selection key={c.nom} libelle={c.libelle} aide={c.aide} required={c.obligatoire} facultatif={!c.obligatoire} optionVide="Choisir" options={c.options} value={valeurs[c.nom] ?? ''} onChange={(e) => setValeurs((v) => ({ ...v, [c.nom]: e.target.value }))} erreur={action.erreursChamps.find((x) => x.champ === c.nom)?.message} />
          ) : c.multiligne ? (
            <ZoneTexte key={c.nom} libelle={c.libelle} aide={c.aide} required={c.obligatoire} facultatif={!c.obligatoire} value={valeurs[c.nom] ?? ''} onChange={(e) => setValeurs((v) => ({ ...v, [c.nom]: e.target.value }))} erreur={action.erreursChamps.find((x) => x.champ === c.nom)?.message} />
          ) : (
            <Champ key={c.nom} libelle={c.libelle} aide={c.aide} required={c.obligatoire} facultatif={!c.obligatoire} value={valeurs[c.nom] ?? ''} onChange={(e) => setValeurs((v) => ({ ...v, [c.nom]: e.target.value }))} erreur={action.erreursChamps.find((x) => x.champ === c.nom)?.message} />
          ),
        )}
        {action.messageErreur ? <Bandeau type="erreur">{action.messageErreur}</Bandeau> : null}
      </DialogueConfirmation>
    </>
  );
}
